import React from 'react'

export default () => {

    const api = 'https://ncc794xp77.execute-api.eu-west-1.amazonaws.com/prod'

    return (
        <div>
            <iframe
                title="onboarding"
                src={`https://onboarding-iframe-app.s3-eu-west-1.amazonaws.com/index.html?token=${localStorage.getItem('token')}&api=${api}`}
                style={{ width: '90vw', height: '80vh', border: 'none' }}
            />
        </div>
    )
}

